import {
  set
} from '../redux/activities'
import _requestAddBookmark from 'store/sagas/requestAddBookmark'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  boardId: number
  id: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { boardId, id } = payload

  const state = getState()

  const activity = state['view-board'].activities[boardId].activitiesById[id]

  let optimisticAction
  if (activity) {
    optimisticAction = optimisticDispatch(dispatch, set({
      boardId,
      activity: {
        id,
        isBookmarked: true
      }
    }))
  }

  try {
    await dispatch(_requestAddBookmark({
      id,
      contextTag: 'board-' + boardId
    }))

    if (optimisticAction) {
      optimisticAction.commit()
    }
  } catch (error) {
    if (optimisticAction) {
      optimisticAction.revert()
    }

    throw error
  }
}

